import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ '../views/home/index')

const Reg = () => import(/* webpackChunkName: "loginReg" */ '../views/reg/index')
const Login = () => import(/* webpackChunkName: "loginReg" */ '../views/login/index')

const Account = () => import(/* webpackChunkName: "account" */ '../views/account/index')

const Realname = () => import(/* webpackChunkName: "realname" */ '../views/realname/index')

const Agreement = () => import(/* webpackChunkName: "agreement" */ '../views/agreement/index')

const Generalize = () => import(/* webpackChunkName: "generalize" */ '../views/generalize')
const GeneralizeWebsite = () => import(/* webpackChunkName: "generalize" */ '../views/generalize/website/index.vue')
const GeneralizeOrder = () => import(/* webpackChunkName: "generalize" */ '../views/generalize/order/index.vue')

const Effect = () => import(/* webpackChunkName: "effectReport" */ '../views/effectReport/index')
const EffectAccount = () => import(/* webpackChunkName: "effectReport" */ '../views/effectReport/account/index')
const EffectOrder = () => import(/* webpackChunkName: "effectReport" */ '../views/effectReport/orderDetail/index')
const EffectStudent = () => import(/* webpackChunkName: "effectReport" */ '../views/effectReport/studentManage/index')
const leadCourse = () => import(/* webpackChunkName: "effectReport" */ '../views/effectReport/leadCourse/index')


Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {title: '首页'}
    },
    {
      path: '/reg',
      name: 'reg',
      component: Reg,
      meta: {title: 'reg', notMenu: true, loginReg: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {title: 'login', notMenu: true, loginReg: true }
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: {title: '账户管理'}
    },
    {
      path: '/realname',
      name: 'realname',
      component: Realname,
      meta: {title: '实名认证'}
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement,
      meta: {title: '用户协议', notMenu: true }
    },
    {
      name: 'generalize',
      path: '/generalize',
      meta: {title: '我要推广'},
      component: Generalize,
      redirect: '/generalize/website',
      children: [
        {
          name: 'generalizeWebsite',
          path: '/generalize/website',
          component: GeneralizeWebsite,
          meta: {title: '网站推广'},
        }, {
          name: 'generalizeOrder',
          path: '/generalize/order',
          component: GeneralizeOrder,
          meta: {title: '订单推广'},
        }
      ]
    },
    {
      name: 'effect',
      path: '/effect',
      meta: {title: '报表效果'},
      component: Effect,
      redirect: '/effect/account',
      children: [
        {
          name: 'effectStudent',
          path: '/effect/effectStudent',
          component: EffectStudent,
          meta: {title: '学生管理'}
        },
        {
          name: 'effectOrder',
          path: '/effect/effectOrder',
          component: EffectOrder,
          meta: {title: '订单明细'}
        },
        {
          name: 'effectAccount',
          path: '/effect/effectAccount',
          component: EffectAccount,
          meta: {title: '收益结算'}
        },
        {
          name: 'leadCourse',
          path: '/effect/leadCourse',
          component: leadCourse,
          meta: {title: '领课列表'}
        }
      ]
    },
    {
      path: '*',
      redirect: '/',
      meta: { notMenu: true }
    }
  ]
})

export default router
